import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Customer, FetchCustomerProps } from '../model/customer.model'

import { StoreError } from '~/common/model'

export type CustomerState = {
  loading: boolean
  error?: StoreError
  data?: Customer
}

export const initialState: CustomerState = {
  loading: false,
  error: undefined,
  data: undefined,
}

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    fetchCustomer: (_state, _action: PayloadAction<FetchCustomerProps>) => {
      return { ...initialState, loading: true }
    },
    fetchCustomerSuccess(_state, action: PayloadAction<Customer>) {
      const { payload } = action
      return { ...initialState, data: payload, loading: false }
    },
    fetchCustomerError(_state, action: PayloadAction<StoreError>) {
      const { payload } = action
      return { ...initialState, error: payload }
    },
  },
})

export const { fetchCustomer, fetchCustomerSuccess, fetchCustomerError } = customerSlice.actions

const customerReducer = customerSlice.reducer
export default customerReducer
